function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 120 64"
}, props), React.createElement("path", {
  d: "M120 37.159v26.05h-6.385V46.432H6.385v16.775H0V0h6.385v24.23h4.613v-3.927a6.233 6.233 0 016.225-6.225H29.4a6.233 6.233 0 016.226 6.225v3.927h71.444c7.119 0 12.929 5.794 12.929 12.929z",
  fill: "#1A79A2"
})));